import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import CondPagtoFrame from './CondPagtoFrame';
import PedidoItemEntregaForm from './PedidoItemEntregaForm';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export const OPCOES_TIPO = [
  { key: 'P', label: 'PEDIDO' },
  { key: 'O', label: 'ORÇAMENTO' },
]

export default class EntregaEditarForm extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_desc: 0,
      ven_vlr_total: 0,
      ven_tipo_venda: { key: 'P' },
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_latitude: 0,
      ven_longitude: 0,
    },
    modalProdutoVisible: false,
    modalEntregaVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",

    listaProdutos: [],
    listaEntregas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroEditarSelecionado !== propsAnterior.registroEditarSelecionado) {
      this.setState({
        registro: this.props.registroEditarSelecionado.dados,
        ven_pessoa: this.props.registroEditarSelecionado.dados.ven_pessoa,
        ven_usuario: this.props.registroEditarSelecionado.dados.ven_usuario,
        ven_cond_pagto: this.props.registroEditarSelecionado.dados.ven_cond_pagto,
        listaProdutos: this.props.registroEditarSelecionado.listaProdutos ? this.props.registroEditarSelecionado.listaProdutos : [],
        listaEntregas: this.props.registroEditarSelecionado.listaEntregas ? this.props.registroEditarSelecionado.listaEntregas : [],
        visualizando: this.props.registroEditarSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        // this.calculoTotalPedido(this.props.registroEditarSelecionado.listaProdutos ? this.props.registroEditarSelecionado.listaProdutos : []);
      });

      if (this.props.registroEditarSelecionado.dados.ven_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }

  onOK = () => {

    if ((this.state.listaEntregas) && (this.state.listaEntregas.length > 0)) {
      for (var y in this.state.listaProdutos) {
        const prod = this.state.listaProdutos[y].prod_idf
        const qtdeProd = this.state.listaProdutos[y].vi_qtde

        let qtdeEntregas = 0
        for (var x in this.state.listaEntregas) {
          if (prod === this.state.listaEntregas[x].vie_item) {
            qtdeEntregas = qtdeEntregas + parseFloat(this.state.listaEntregas[x].vie_qtde);
          }
        };
        if (qtdeEntregas) {
          let qtdeDif = parseFloat((parseFloat(qtdeEntregas) - parseFloat(qtdeProd)).toFixed(2));
          if (qtdeDif !== 0) {
            Modal.warning({ title: 'Aviso!', content: 'Qtde das entregas é diferente da quantidade total dos itens' });
            return;
          }
        }
      }
    }

    const registro = {
      ven_idf: this.state.registro.ven_idf,
      listaProdutos: this.state.listaProdutos,
      listaEntregas: this.state.listaEntregas,
    };

    this.props.onSalvarClick(registro);
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {prod_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        {this.state.usuario.par_entrega_itens_vendas ? (
          <Tooltip title="Entregas" placement="right">
            <Button className="botoesModalFormEditar" onClick={() => this.onEntregaProdutosClick(registro)} icon="car" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };




  // ----------------------------------------------------------------
  // ENTREGAS
  // ----------------------------------------------------------------

  onFecharModalEntregaClick = () => {
    this.setState({
      modalEntregaVisible: false,
    });
  }

  onEntregaProdutosClick = (reg) => {
    this.setState({
      modalEntregaVisible: true,
      produtoEntregaSelecionado: {
        editando: !this.state.visualizando,
        prod_idf: reg.prod_idf,
        vi_seq: reg.vi_seq,
        vi_qtde: reg.vi_qtde,
      }
    });
  }

  onSalvarEntregasClick = (listaEntregas) => {
    this.setState({
      modalEntregaVisible: false,
      listaEntregas,
    },
      // this.calculoTotalPedido(listaProdutos)
    );
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarEditarClick, carregando, visivel } = this.props;

    const { carregandoForm, listaProdutos, listaEntregas, produtoSelecionado, produtoEntregaSelecionado,
      vlrDifParc, vlrTotalParc, modalEntregaVisible, modalParcelaVisible, modalProdutoVisible } = this.state;

    const { ven_idf, ven_numero, ven_dt_venda, ven_pessoa, ven_obs, ven_cond_pagto,
      ven_qtde_itens, ven_vlr_total, ven_usuario, ven_tipo_venda, ven_dados_cliente } = this.state.registro;

    // console.log('PedidoForm.this.state: ', this.state);

    return (
      <Modal
        title={"Produtos do Pedido"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarEditarClick}
        footer={null}
        width={"70%"}
        style={{ top: 10 }}
      >

        <PedidoItemEntregaForm
          visivel={modalEntregaVisible}
          onSalvarEntregasClick={this.onSalvarEntregasClick}
          onFecharModalEntregaClick={this.onFecharModalEntregaClick}
          produtoEntregaSelecionado={produtoEntregaSelecionado}
          listaEntregas={listaEntregas}
        />


        <div style={{ height: 350 }}>
          <Table
            loading={{
              spinning: carregandoForm,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaProdutos}
            pagination={false}
            scroll={{ x: 600, y: 300 }}
            rowKey={(listaProdutos => listaProdutos.vi_item)}
          >
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title="Código"
              width={60}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title="Descrição"
              width={360}
              align="left"
              className="listaCadastro"
              render={this.renderDescrProduto}
            />
            <Column
              key="vi_qtde"
              dataIndex="vi_qtde"
              title="Qtde"
              render={this.renderValor}
              width={70}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title=""
              render={this.renderAcoesProdutos}
              width={90}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando ? null : (
                  <Button
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar Entregas
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarEditarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EntregaEditarForm.js